import "react-circular-progressbar/dist/styles.css";

import { Box, Flex, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../components/DetailWrapper/detailWrapper";
import useVipInfo from "../../hook/useVipInfo";
import MainCard from "./components/mainCard";
import ProgressCard from "./components/progressCard";
import VipListCard from "./components/vipList";
import VipPromotionList from "./components/vipPromotionList";

const SimpleVip = () => {
  const { t } = useTranslation();
  const i18n = (key, props) => t(`vip.${key}`, { ...props });

  const vipInfo = useVipInfo();
  const vipList = useSelector((state) => state.isVipDetail);

  const { current_level, current_wager } = vipInfo;

  const navigate = useNavigate();

  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <article className="mt-[20px] flex flex-col gap-[20px]">
        <Flex alignItems="center" justifyContent="between" px={"5px"}>
          <Text
            fontSize="xl"
            fontWeight="medium"
            color="base.light.dark"
            _dark={{ color: "base.light.white" }}
          >
            {i18n("myLevel")}
          </Text>
          {/* <span className="py-[1px] px-[10px] rounded-full bg-base-light-white dark:bg-base-light-dark text-sm text-dark-gray-text dark:text-base-light-white font-semibold tracking-tighter">
            {i18n("leftDays", { day: 30 })}
          </span> */}
        </Flex>

        <MainCard currentWager={current_wager} currentLevel={current_level} />
        <Box>
          <Text
            fontSize="xl"
            fontWeight="medium"
            color="base.light.dark"
            _dark={{ color: "base.light.white" }}
          >
            {i18n("nextLevel")}
          </Text>
        </Box>
        <Flex
          bg="background.transactionCard"
          _dark={{ bg: "light.400" }}
          p="8px"
          rounded="5px"
          flexDirection="column"
          gap="10px"
        >
          <ProgressCard
            currentWager={current_wager}
            currentLevel={current_level}
          />
          <VipPromotionList customLevel={1} />
        </Flex>

        <VipListCard />
      </article>
    </DetailWrapper>
  );
};

export default SimpleVip;
